import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './file-with-popover-error-status.scss';
import React from 'react';
import Popover from 'researcher/components/Popover';
import { useTranslate } from 'shared/helper/translate';
import { FILE_STATUS } from '../constants';
var FileWithPopoverErrorStatus = function FileWithPopoverErrorStatus(_ref) {
  var disabled = _ref.disabled,
    file = _ref.file,
    removeFile = _ref.removeFile;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "file-with-popover-error-status clearfix position-relative ".concat(file.status === FILE_STATUS.STATUS_FILETYPE_FAILURE ? 'text-danger' : '', " pb-1")
  }, /*#__PURE__*/React.createElement("div", {
    className: "float-end"
  }, file.status === FILE_STATUS.STATUS_UPLOAD_PROCESSING ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link p-0 m-0 bg-transparent text-muted",
    "aria-label": "".concat(t('remove'), " ").concat(file.name),
    disabled: disabled,
    onClick: removeFile,
    type: "button"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-times-circle"
  }))), /*#__PURE__*/React.createElement(PopoverFileStatus, {
    file: file
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-name text-truncate"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: "fa-solid fa-file-text"
  }), file.name)));
};
var PopoverFileStatus = function PopoverFileStatus(_ref2) {
  var file = _ref2.file,
    children = _ref2.children;
  switch (file.status) {
    case FILE_STATUS.STATUS_FILETYPE_FAILURE:
      return /*#__PURE__*/React.createElement(Popover, {
        content: "Filetype not allowed"
      }, children);
    default:
      return children;
  }
};
export default FileWithPopoverErrorStatus;